import React, { useState } from "react";
import API from "../../Utils/api";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: "",
    phoneNumber: "",
    newPassword: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleReset = async (e) => {
    e.preventDefault();

    try {
      const res = await API.post("/admins/admin-forgot-password", data);
      alert(res.data.message);
      navigate("/login");
    } catch (err) {
      alert(err.response?.data?.message || "Error");
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4
    bg-gradient-to-br from-[#3A7138] via-[#4f8c4d] to-[#1A3617]"
    >
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 sm:p-10">
        {/* Heading */}
        <h2 className="text-3xl font-serif text-center text-[#1A3617]">
          Forgot Password
        </h2>

        <p className="text-sm text-gray-500 text-center mt-2">
          Enter your details to reset your password
        </p>

        {/* Form */}
        <form onSubmit={handleReset} className="mt-8 space-y-5">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-xl border border-gray-300 
            focus:outline-none focus:ring-2 focus:ring-[#3A7138]"
          />

          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-xl border border-gray-300 
            focus:outline-none focus:ring-2 focus:ring-[#3A7138]"
          />

          <input
            type="password"
            name="newPassword"
            placeholder="New Password"
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-xl border border-gray-300 
            focus:outline-none focus:ring-2 focus:ring-[#3A7138]"
          />

          {/* Button */}
          <button
            type="submit"
            className="w-full py-3 rounded-xl text-white font-semibold
            bg-gradient-to-r from-[#3A7138] to-[#1A3617]
            hover:opacity-90 transition shadow-lg"
          >
            Reset Password
          </button>
        </form>

        {/* Back */}
        <p className="text-center text-sm text-gray-500 mt-6">
          Remember your password?{" "}
          <span
            onClick={() => navigate("/login")}
            className="text-[#3A7138] cursor-pointer font-semibold hover:underline"
          >
            Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
